import React, { CSSProperties, FC, ReactNode } from 'react';
import { CalendarLabel } from 'shared/pages/projectEdit/components/LMS/LessonsEditor/styles';
import { RequiredStar } from 'shared/pages/CourseEdit/styles';

type FieldLabelProps = {
  children: ReactNode;
  required?: boolean;
  style?: CSSProperties;
};

export const FieldLabel: FC<FieldLabelProps> = ({ children, required, style }) => (
  <CalendarLabel style={style}>
    {children}
    {required ? <RequiredStar>*</RequiredStar> : null}
  </CalendarLabel>
);
import React, { CSSProperties, FC, ReactNode } from 'react';
import { CalendarLabel } from 'shared/pages/projectEdit/components/LMS/LessonsEditor/styles';
import { RequiredStar } from 'shared/pages/CourseEdit/styles';

type FieldLabelProps = {
  children: ReactNode;
  required?: boolean;
  style?: CSSProperties;
};

export const FieldLabel: FC<FieldLabelProps> = ({ children, required, style }) => (
  <CalendarLabel style={style}>
    {children}
    {required ? <RequiredStar>*</RequiredStar> : null}
  </CalendarLabel>
);
